import { render, staticRenderFns } from "./NewPasswordPanel.vue?vue&type=template&id=4325cccf&scoped=true"
import script from "./NewPasswordPanel.vue?vue&type=script&lang=js"
export * from "./NewPasswordPanel.vue?vue&type=script&lang=js"
import style0 from "./NewPasswordPanel.vue?vue&type=style&index=0&id=4325cccf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4325cccf",
  null
  
)

export default component.exports